var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickSettle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_7667_8586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7667_8586",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7667_8586",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7667_8586",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEVklEQVR4nO2duWtVQRSHR4lxwyUo2LigpVHcre3EBBQLa7VRUOzUVrFQoyS4oYUriPoPaKXGJk0sbNxQFLERFQm4b9FPBicQHknuuffOvbO8+eDBg8C5vzknM3fOmeUplUgkEolEJABHXWtoavhPCoLjAGhSEBwHII4gAO+BgWGfQbJ5AYx3pLeRgypkgF8UY4MjvSMRbk8AflKMm470ElUQgB8U4w+w0IFeogoC8I3idDnQS1RBAL5SnA/ApJr1ElUQgM+UY2vNeqVYnR0BW4D5Nm3aCkC/dVFjkFOblZ4AzDUjhZ6wnARm2LA7ZHwm0DbsM6Xh7/sFDV2d43l1U7onAFcbbOrcaRfQUta25OGzgO8ZjbyUw54LCvcEYLmZ8Y3EMz00FbWdR8SVjAbqmdQsoS1XFOoJwD2B7c1FbOcRsVYgYq/Qlkty9QRgk8Dmk7qGovsZQl5K6kO45UCO9rYAj70pyQDbbIghAOcbnbsFNntLOTWnoMkm8SpVHyIM508D3mbY1C/mlapOgONl60N47nyj8YjArnjmZw1g0RhTslrqQ1Tv/KGkK2vWN6+aFmYLvOWyPkSFzh8l6RqJQ/ZbJhfY6bI+RLXOHyvpGuIdMN1+y+QixwHPXdWHqMj5xvYdgf0ddltUTOg+gdA1FT27Kuf7k3QJxLYJXlSXK3p2Fc6XJl0dyhds1ofyYNv5XiZdEnQSYqs+lIcKnO9n0lVnfSgPNp3vddJlsT7UYfmZNp3vd9KVBTDRrA7Vtn8IS84PIumSAByrc/8QlhbbgVWCpEu/G6YpnwEWCPaTdinPCCbpCqE+lBdgYzBJlwT9ovVt/1BUSZfv9aHoky7f60MVJF2rVGi4rA9ZTrqcaiyFFu+iPmQ56bK//7MugBUu6kNNk3RZqg/5ituVLlvo6SZhslPFgLA+5BtPg0m6JADnCYtOFQvAHHPeOBQuqpgArhMO/Y0HUoIGWE8Y/AUu+FQgtLV5V19h4CsfgQfAGWCxig3gsMAJr4CprrVGB9AuvHOi07XW6NC7HoA+gfOvudYaJcB2gfMH9PTUtdZY//v1uB7H2mpo6AUWgfP7XF3uFD2C4ec3sMy1zmjRe3QyAnDDtcaoAfYQOcpnhPtrgkYFUH4IqfKZG+U7wCkiRvkOMBt4Q6SoENAXNplF7ehQoWD23UhqQkGhQgNYZ1bFXpe4ldcbXPszkUgkEgkxwFJzuekj4Iv56O8ngCWuXem7vrJbEs9mnDwcNLsSWpM++87vzTG7u1tnEHzXVxrgHPk5nfTZG1OzDjyPNhy1N7u+0pgXWlF6ml1faYRnbkfjYbPrc/37A5+aXV9ptMgSDfzY7Pqi7+J4rq80JoMsSnez6yuNTt+FP3/YyGAd+/R912cFU17Iy8mkz14AWoUXIA1xG5hQYwC81mezkaczuvugSYxqb5zv+myflunRMwj+z8E/m+/dPoypvutLJBKJRCKRSCQSKnj+AbiidCzgkG/BAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSettle);
export default __webpack_public_path__ + "static/media/quick_settle.a813f97339f45984ccfe690a80e690bd.svg";
export { ForwardRef as ReactComponent };